import { render, staticRenderFns } from "./ChildAccounts.vue?vue&type=template&id=b37c7602&"
import script from "./ChildAccounts.vue?vue&type=script&lang=js&"
export * from "./ChildAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports